// extracted by mini-css-extract-plugin
export default {"page":"App_page__5vKaD","siteHeader":"App_siteHeader__wpP8k","siteName":"App_siteName__eOpzd","sideColumn":"App_sideColumn__AH9Op","mainGrid":"App_mainGrid__qQpNb"};